import { render } from "./Masterdata.vue?vue&type=template&id=620e2d60"
import script from "./Masterdata.vue?vue&type=script&lang=js"
export * from "./Masterdata.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__